<template>
  <div>
    <b-row>
      <b-col cols="6"><h2>Welcome, {{recipientNickname}}!!!!</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="margin-bottom: 15px;">
        <p>Welcome to the PonyEngine Circle! You're now part of a caring community.<p>
        <p>Feel free to explore and connect with your heartbeat at:</p>
        <b-link
            style="box-shadow: none;"
            @click="handleGoToHeartBeat"
        >
             https://heartbeatfam.com/heartbeat/{{heartBeatSlug}}
           </b-link>
        <br />
        <br />
        <p>
          You will also have a menu item dedicated to your heartbeat (See right image.)
        </p>
        <p> Don't forget to check out the oue blogs for more information and updates. ❤️👨‍👩‍👧‍👦🎉
        </p>
      </b-col>
      <b-col cols="4">
        <b-row>
          <b-col cols="6">
            <b-card
                tag="article"
                style="max-width: 30rem;"
                class="mb-2"
            >
              <b-card-text>
                MyApps
              </b-card-text>
              <b-card-text>
                Settings
              </b-card-text>
              <b-card-text>
                Pricing
              </b-card-text>
              <b-card-text>
                <hr/>
                <b-row>
                  <b-col
                      style="cursor: pointer"
                      @click="handleGoToHeartBeat"
                  >
                    <small>💛 {{ heartBeatName }} </small>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RecordViews from "@/mixins/RecordViews";
import moment from "moment";
export default {
  name: "Family_Invite_Notice",
  mixins: [RecordViews],
  components: {},
  props: {
    invitation: {
      type: Object,
      required: true
    },
  },
  mounted() {},
  computed: {
    ...mapGetters({
      user: "user/user",
      profile:"user/profile"
    }),
    heartBeatSlug() {
      return this.invitation  && this.invitation.heartbeat && this.invitation.heartbeat.slug ?
          this.invitation.heartbeat.slug
          : null;
    },
    heartBeatName() {
      return this.invitation  && this.invitation.heartbeat && this.invitation.heartbeat.name ?
          this.invitation.heartbeat.name
          : null;
    },
    heartBeatImgURL() {
      return this.invitation  && this.invitation.heartbeat && this.invitation.heartbeat.imgURL ?
          this.invitation.heartbeat.imgURL
          : null;
    },
    recipientNickname() {
      return this.invitation  && this.invitation.rec && this.invitation.rec.nickname ?
          this.invitation.rec.nickname
          : null;
    },
    expiration() {
      return this.invitation  && this.invitation._expire_at ?
          this.formatDate(this.invitation._expire_at)
          : null;
    },
  },
  methods: {
    recordView(publishingId) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "invites",
        entityId: publishingId,
        feedbackType: "views",
        sessionId: this.checkSession("sessions")
      });
    },
    handleInvitationResponse(hasAccepted){
      this.$emit('invitation-response', hasAccepted);
    },
    formatDate(date) {
      return date
          ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
          : "N/A";
    },
    handleGoToHeartBeat(){
      this.$router.push(`heartbeat/${this.heartBeatSlug}`);
    }
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:title", content: this.blogTitle },
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.logo },
        { property: "og:title", content: this.blogTitle },
        { property: "og:site_name", content: "JourneyBinder" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: this.description }
      ]
    };
  },
  data() {
    return {
      userHasAccepted: null,
      openForm: false,
      mainProps: { blank: false, width: 100, height: 100, class: 'm1' },
      invitation: null,
      invitationState:'initial', //initial/rejected/approved
      inviteCode: null,
    };
  },
};
</script>
